import { render, staticRenderFns } from "./ListDiscount.vue?vue&type=template&id=26fb6f64&"
import script from "./ListDiscount.vue?vue&type=script&lang=js&"
export * from "./ListDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports